import { axios } from '@/utils/request';

let Api = {
  resultsAnalysis: '/api/analysis/submit',
  streamAnalysis: '/api/analysis/stream/submit',
  taskStatus: '/api/analysis/task/', // 获取 成果分析 状态
  createTask: '/api/analysis/create-task', // 成果分析
  analysisDetail: '/api/analysis/result/', // 成果分析详情 非流式
  achievementPdf: '/api/analysis/pdf/', // 成果分析 导出PDF
  correlationAnalyze: '/api/analysis/correlation_analyze',
  recreateTask: '/api/analysis/recreate-task', // 重新生成 成果分析
};

// 成果分析
export const resultsAnalysisApi = (params) => {
  return axios.post(Api.resultsAnalysis, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000
  });
};

// 获取 成果分析 状态
export const taskStatusApi = (id) => {
  return axios.get(Api.taskStatus + id)
}

// 成果分析 新
export const createTaskApi = (params) => {
  return axios.post(Api.createTask, params, {
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 600000
  })
}

// 重新生成 成果分析
export const recreateTaskApi = (id) => {
  return axios.post(Api.recreateTask + '?oldTaskId=' + id)
}


// 成果分析详情 非流式
export const analysisDetailApi = (id) => {
  return axios.get(Api.analysisDetail + id);
}

// 成果分析 导出PDF
export const achievementPdfApi = (id) => {
  return axios.get(Api.achievementPdf + id);
}

// 相关性分析
export const correlationAnalyzeApi = (params) => {
  return axios.post(Api.correlationAnalyze, params)
}